<!-- 企业级-用户管理-组织管理-权限分配 -->
<template>
  <div class="mainArea COrganizeAuthAllot">
      <!-- 主要头部内容 -->
      <div class="mainHeadContent">
        <!-- 面包屑 -->
        <CBreadCrumb></CBreadCrumb>
      </div>
      <!--主内容区-->
      <div class="mainBodyContent">
        <!-- <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="后台权限" name="1">
            <el-tree
              class="roleTree"
              v-loading="roleAuthData.loading"
              ref="role"
              :data="roleAuthData.list"
              :props="defaultProps"
              node-key="function_id"
              :default-checked-keys="roleAuthData.roleAccess"
              show-checkbox
              default-expand-all>
            </el-tree>
            <el-button
              class="confirm"
              type="primary"
              @click="getCheckedKeys"
              v-if="roleAuthData.list.length !== 0">确 认</el-button>
          </el-tab-pane>
          <el-tab-pane label="仓储业务" name="2">
            <el-tree
              class="roleTree"
              v-loading="roleAuthData.loading"
              ref="role"
              :data="roleAuthData.list"
              :props="defaultProps"
              node-key="function_id"
              :default-checked-keys="roleAuthData.roleAccess"
              show-checkbox
              default-expand-all>
            </el-tree>
            <el-button
              class="confirm"
              type="primary"
              @click="getCheckedKeys"
              v-if="roleAuthData.list.length !== 0">确 认</el-button>
          </el-tab-pane>
        </el-tabs> -->
        <!-- 权限列表 -->
        <el-tree
          class="roleTree"
          v-loading="roleAuthData.loading"
          ref="role"
          :data="roleAuthData.list"
          :props="defaultProps"
          node-key="function_id"
          :default-checked-keys="roleAuthData.roleAccess"
          show-checkbox
          default-expand-all>
        </el-tree>
        <el-button
          class="confirm"
          type="primary"
          @click="getCheckedKeys"
          v-if="roleAuthData.list.length !== 0">确 认</el-button>
      </div>
  </div>
</template>

<script>
  import CBreadCrumb from "../../Layout/CBreadCrumb.vue"
  import { showToast } from "../../../../../static/js/utility/utility.js"
  import { userApi } from "../../../../../static/js/api.js"

  export default {
    name: 'COrganizeAuthAllot',
    components: {
      CBreadCrumb
    },
    data() {
      return {
        activeName: '1',
        // 角色权限数据
        roleAuthData: {
          // 权限列表
          list: [],
          loading: false,
          // 已选中权限
          roleAccess: []
        },
        // 树形控件默认控件
        defaultProps: {
          children: 'children',
          label: 'function_name'
        }
      }
    },
    mounted(){
      this.getRoleAuth()
    },
    created: async function () {
    },
    methods: {
      handleClick(tab, event) {
        console.log(tab, event);
      },
      // 获取角色权限详情
      getRoleAuth: async function () {
        let vm = this
        let data = {
          role_id: vm.$route.query.role_id
        }
        vm.roleAuthData.loading = true
        let res = await userApi.getRoleAuth(data)
        vm.roleAuthData.loading = false
        if (res.meta.code === 200) {
          vm.roleAuthData.list = [...res.data.companyAccessList]
          vm.roleAuthData.roleAccess = [...res.data.roleAccess]
          // console.log('vm.roleAuthData.roleAccess', vm.roleAuthData.roleAccess)
        } else {
          showToast(res.meta.message)
        }
      },
      // 更新角色权限
      updateRoleAuth: async function (roleAccess) {
        let vm = this
        let data = {
          role_id: vm.$route.query.role_id,
          roleAccess: [...roleAccess]
        }

        // console.log('data', data)
        // return

        let res = await userApi.updateRoleAuth(data)
        if (res.meta.code === 200) {
          // console.log('res', res)
          showToast('更新权限成功')
          // 返回上一页
          setTimeout(function () {
            vm.$store.state.authSuccessShowTab = 'auth'
            vm.$router.go(-1)
          }, 1000)
        } else {
          showToast(res.meta.message)
        }
      },
      // 确认更新权限
      getCheckedKeys() {
        let roleAccess = this.$refs.role.getCheckedKeys()
        // console.log('roleAccess', roleAccess)
        this.updateRoleAuth(roleAccess)
      }
    },
    watch: {
      // 监听vuex的值变化
      "$store.state.buildingID":async function(newVal, oldVal) {
        this.buildingID = newVal;
      }
    }
  }
</script>

<style lang="scss">
.COrganizeAuthAllot {
  .roleTree>.el-tree-node {
      margin-bottom: 20px;
  }

  .roleTree .el-tree-node__children>.el-tree-node {
      float: left;
  }
  .el-tabs__header {
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    border-bottom: 1px solid #E4E7ED;
  }
}


</style>



// WEBPACK FOOTER //
// src/components/Page/CUserManege/COrganizeManage/COrganizeAuthAllot.vue